// extracted by mini-css-extract-plugin
export default {"content-container":"styles_content-container__aj4wc"};